export default {
  notifications: [],
  totalFromServer: 0,
  watched: 0,
  unwatched: 0,
  notificationsMenu: [],
  totalFromServerMenu: 0
}
